// ============================================
// TECNOSAUNA — JavaScript
// ============================================

document.addEventListener('DOMContentLoaded', () => {
  // Mobile Menu Toggle
  const toggle = document.getElementById('navToggle');
  const navLinks = document.getElementById('navLinks');

  if (toggle && navLinks) {
    toggle.addEventListener('click', () => {
      navLinks.classList.toggle('open');
      document.body.classList.toggle('menu-open');
      const spans = toggle.querySelectorAll('span');
      if (navLinks.classList.contains('open')) {
        spans[0].style.transform = 'rotate(45deg) translate(5px, 5px)';
        spans[1].style.opacity = '0';
        spans[2].style.transform = 'rotate(-45deg) translate(5px, -5px)';
      } else {
        spans[0].style.transform = '';
        spans[1].style.opacity = '';
        spans[2].style.transform = '';
      }
    });

    // Close on link click
    navLinks.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        navLinks.classList.remove('open');
        document.body.classList.remove('menu-open');
        const spans = toggle.querySelectorAll('span');
        spans[0].style.transform = '';
        spans[1].style.opacity = '';
        spans[2].style.transform = '';
      });
    });

    // Mobile: tap on dropdown toggle opens sub-links
    // Desktop: dropdown opens via CSS :hover only — click does nothing
    const dropdownToggles = document.querySelectorAll('.navbar__dropdown-toggle');
    dropdownToggles.forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        // Only toggle on mobile
        if (window.innerWidth <= 1199 /* = breakpoint do hambúrguer no CSS */) {
          const parent = btn.closest('.navbar__dropdown');
          const menu = parent.querySelector('.navbar__dropdown-menu');
          if (menu) {
            const isOpen = menu.classList.contains('dropdown-open');
            // Close all other dropdowns first
            document.querySelectorAll('.navbar__dropdown-menu').forEach(m => {
              if (m !== menu) m.classList.remove('dropdown-open');
            });
            // Toggle current
            menu.classList.toggle('dropdown-open', !isOpen);
            // Rotate arrow
            const svg = btn.querySelector('svg');
            if (svg) svg.style.transform = isOpen ? '' : 'rotate(180deg)';
          }
        }
        // Desktop: do absolutely nothing on click
      });
    });
  }

  // Navbar scroll effect
  const navbar = document.getElementById('navbar');
  const heroSection = document.querySelector('.hero');
  if (navbar) {
    if (heroSection) {
      // On pages with hero: transparent navbar, scrolled on scroll
      window.addEventListener('scroll', () => {
        if (window.scrollY > 80) {
          navbar.classList.add('scrolled');
        } else {
          navbar.classList.remove('scrolled');
        }
      });
    } else {
      // On pages without hero: always solid background
      navbar.classList.add('scrolled');
    }
  }

  // Scroll Reveal
  const revealElements = document.querySelectorAll('.reveal');
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -50px 0px' });

  revealElements.forEach(el => revealObserver.observe(el));

  // Project & Product Filters
  const filterBtns = document.querySelectorAll('.filter-btn');
  const filterableCards = document.querySelectorAll('.project-card, .product-card');

  if (filterBtns.length > 0) {
    filterBtns.forEach(btn => {
      btn.addEventListener('click', () => {
        const filter = btn.dataset.filter;

        filterBtns.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');

        filterableCards.forEach(card => {
          if (filter === 'all' || card.dataset.category === filter) {
            card.style.display = '';
            setTimeout(() => card.style.opacity = '1', 50);
          } else {
            card.style.opacity = '0';
            setTimeout(() => card.style.display = 'none', 300);
          }
        });
      });
    });
  }

  // Contact Form → WhatsApp
  const form = document.getElementById('contactForm');
  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const name = document.getElementById('name').value;
      const phone = document.getElementById('phone').value;
      const email = document.getElementById('email').value;
      const product = document.getElementById('product').value;
      const message = document.getElementById('message').value;

      const text = `*Pedido de Orçamento — TecnoSauna*%0A%0A` +
        `*Nome:* ${name}%0A` +
        `*Telefone:* ${phone}%0A` +
        `*Email:* ${email}%0A` +
        `*Produto:* ${product}%0A` +
        `*Mensagem:* ${message}`;

      window.open(`https://wa.me/351961046495?text=${text}`, '_blank');
    });
  }

  // Smooth scroll for anchor links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Video Lightbox
  const playBtn = document.getElementById('heroPlayBtn');
  const lightbox = document.getElementById('videoLightbox');
  const closeBtn = document.getElementById('videoCloseBtn');
  const backdrop = document.getElementById('videoLightboxClose');
  const iframe = document.getElementById('videoIframe');

  function openLightbox() {
    if (!lightbox || !iframe) return;
    lightbox.classList.add('active');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    // Lazy-load: set iframe src from data-src
    const src = iframe.getAttribute('data-src');
    if (src) iframe.setAttribute('src', src);
  }

  function closeLightbox() {
    if (!lightbox || !iframe) return;
    lightbox.classList.remove('active');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    // Stop video by clearing src
    iframe.setAttribute('src', '');
  }

  if (playBtn) playBtn.addEventListener('click', openLightbox);
  if (closeBtn) closeBtn.addEventListener('click', closeLightbox);
  if (backdrop) backdrop.addEventListener('click', closeLightbox);

  // Close on Escape
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && lightbox && lightbox.classList.contains('active')) {
      closeLightbox();
    }
  });

  // Inline Video Player (in the section)
  const inlinePlayBtn = document.getElementById('inlinePlayBtn');
  const inlinePoster = document.getElementById('inlineVideoPoster');
  const inlineFrame = document.getElementById('inlineVideoFrame');
  const inlineIframe = document.getElementById('inlineIframe');

  if (inlinePlayBtn && inlinePoster && inlineFrame && inlineIframe) {
    function playInlineVideo() {
      inlinePoster.style.display = 'none';
      inlineFrame.style.display = 'block';
      const src = inlineIframe.getAttribute('data-src');
      if (src) inlineIframe.setAttribute('src', src);
    }

    inlinePlayBtn.addEventListener('click', playInlineVideo);
    inlinePoster.addEventListener('click', playInlineVideo);
  }
});
